/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {TwoColorIconProps} from '../IconTypes';

/**
 * ![CircleQuestionIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACIUlEQVR4nMVVPW8TQRA9QQEpCNhSJJREFAjR0lpuaCzr7L2dWQd2ZxSETPgRKEoKfgAFdPwEqiQu+AFIqZIoBJoklBAEVHwEFMSHBJpLiH327XlNASuNdDrdvpl5b+ZdFP3PY60tg+HbgNzRhnfB0BeJo+cVADen1Gzpb4DHwNAiGPoEhn8VhUb+qJEW5E4QOABPAvL6MGDoT2RoK0nshULwVuvGNBh+PSo4HHdDe0rZKT8tyJs5F39odA+UclcqlcpYs2nPJ0g3NfILTycbV9vt04PUpJwPVPQ9MdSIouhEf8RxPA5Iq/nd0Hx/9eVcQdF1BEza1kiPNfKBTJACvn74fuaiFJEnfGa60lHMbZf3wbi7gLTT31mjYS5LEkB64tHjVjcBcmdUQRVw6zCBW/JosXycwCeYP+hdHNsJSaCRtz3d73YTpFQEAT/XSA/r2l5KNUDX9O8F74+UQBvaiqLo5J8p0tpVAPltWIIQipCfCXCtVjurkR5p5G/FBfVQlBrX0C3lz9KBUqoURCfyUo//uLmQSxr4XmLoftC3htuZRZPlCBD5PSB9DdDrA2L7XGabxXKHXHxZrcIZ8aQAOu8MeJEYlBiV/xK9qddtuYnXqsXgtJZrdnKOPGevoLIDjfyzgPdX8j/JBe8KzpNSRdCkmAzvT4f+cHrpEssNEV4EFc7jOD4VBJ6lbLYkrpjuCdKO7IJE+mxoWUZxYFr+9fkN6AbPexjQZTkAAAAASUVORK5CYII=)
 */
export const CircleQuestionIcon = ({
  size = 'md',
  width,
  height,
  secondaryColor = 'transparent',
  secondaryColorClass = '',
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: TwoColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill={typeof secondaryColor === 'string' ? secondaryColor : secondaryColor.css}
        className={secondaryColorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm-.28-16c-.98 0-1.81.47-2.27 1.14A1 1 0 1 1 7.8 7.01 4.73 4.73 0 0 1 11.72 5c2.5 0 4.65 1.88 4.65 4.38 0 2.1-1.54 3.77-3.52 4.24l.14 1a1 1 0 0 1-1.98.27l-.28-2a1 1 0 0 1 .99-1.14c1.54 0 2.65-1.14 2.65-2.38 0-1.23-1.1-2.37-2.65-2.37ZM13 17.88a1.13 1.13 0 1 1-2.25 0 1.13 1.13 0 0 1 2.25 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
